import { Expose, Type } from 'class-transformer'

import { Client } from './Client'

export class Cart {
  static type = 'cart'

  type = Cart.type

  guid: string = ''

  @Type(() => Client)
  client: Client = new Client()

  name: string = ''

  @Expose({ name: 'auto_sync' })
  autoSync: boolean = false
}
